import { useState } from 'react';

const FenceFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does fence installation cost in El Paso?',
      answer: 'Fence installation costs in El Paso typically range from $15-$50 per linear foot depending on material and style. Chain link fencing is most affordable at $15-$25 per foot, wood fencing ranges $20-$35 per foot, vinyl costs $25-$40 per foot, and wrought iron or aluminum can be $30-$50+ per foot. Total project costs depend on fence length, height, terrain, gates, and additional features.'
    },
    {
      question: 'What type of fence is best for El Paso weather?',
      answer: 'For El Paso\'s hot, dry climate with intense sun exposure, vinyl and aluminum fencing perform exceptionally well as they resist fading, warping, and require minimal maintenance. Cedar wood fencing is also popular when properly sealed and maintained. Chain link and wrought iron are durable options but may require rust prevention treatments. Composite fencing offers excellent weather resistance with low maintenance requirements.'
    },
    {
      question: 'Do I need a permit to install a fence in El Paso?',
      answer: 'Yes, most fence installations in El Paso require a building permit from the City of El Paso Building Inspection Department. Permits are typically required for fences over 6 feet tall or any fence in a front yard. Your fence contractor should handle permit applications and ensure compliance with local zoning regulations, setback requirements, and HOA rules if applicable.'
    },
    {
      question: 'How long does fence installation take?',
      answer: 'Most residential fence installations in El Paso take 2-5 days to complete depending on project size and complexity. A typical 150-200 linear foot fence can be installed in 2-3 days. Factors affecting timeline include fence type, terrain difficulty, concrete curing time for posts, weather conditions, and permit approval. Commercial projects or complex installations may take 1-2 weeks.'
    },
    {
      question: 'What is the best fence height for privacy in El Paso?',
      answer: 'For optimal privacy in El Paso residential properties, 6-foot tall fencing is most common and effective. This height blocks views from ground level while complying with most local regulations. Some homeowners choose 8-foot fencing for maximum privacy, though this may require special permits. Front yard fences are typically limited to 3-4 feet in height per El Paso zoning codes.'
    },
    {
      question: 'How do I maintain my fence in El Paso?',
      answer: 'Fence maintenance in El Paso varies by material. Wood fences should be cleaned annually and re-stained or sealed every 2-3 years to protect against sun damage. Vinyl fences need occasional washing with soap and water. Metal fences should be inspected for rust and touched up with paint as needed. All fences benefit from regular inspections of posts, panels, and hardware, with prompt repairs preventing larger issues.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about fence installation and contractors in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-orange-600 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FenceFAQ;
